/* eslint-disable @next/next/no-img-element */

import { FormValues } from "@ui/types";
import { ReactNode } from "react";
import { Form, FormRenderProps } from "react-final-form";

export interface AuthFormProps {
  title: ReactNode;
  subtitle?: ReactNode;
  onSubmit: (values: FormValues) => void;
  validate?: (...args: any) => any;
  initialValues: FormValues;
  children?: ((formRenderProps: FormRenderProps) => ReactNode) | ReactNode;
  render?: (formRenderProps: FormRenderProps) => ReactNode;
  hideLogo?: boolean;
}

function AuthForm({
  title,
  subtitle,
  hideLogo,
  onSubmit,
  validate,
  initialValues,
  children,
  render,
}: AuthFormProps) {
  return (
    <div>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="py-8">
          {!hideLogo && (
            <img className="w-auto h-10 mx-auto mb-4" src="/images/icon.png" alt="Helios" />
          )}
          <div className="mb-6">
            {typeof title === "string" ? (
              <h2 className="text-2xl font-semibold text-center text-foreground">{title}</h2>
            ) : (
              title
            )}
            {typeof subtitle === "string" ? (
              <p className="text-sm text-center text-muted-foreground">{subtitle}</p>
            ) : (
              subtitle
            )}
          </div>
          <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={({ handleSubmit, ...formRenderProps }) => {
              return (
                <form onSubmit={handleSubmit}>
                  {render && typeof render === "function"
                    ? render({ handleSubmit, ...formRenderProps })
                    : typeof children === "function"
                      ? children({ handleSubmit, ...formRenderProps })
                      : children}
                </form>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AuthForm;
